import { AllMarketTypes, BetTypeCalculationTypes } from '../enums';

export const getBetCalculationType = (type) => {
  switch (type) {
    case AllMarketTypes.Red:
    case AllMarketTypes.Black:
      return BetTypeCalculationTypes.Colors;
    case AllMarketTypes.J_Q:
    case AllMarketTypes.J_Q_K_A:
    case AllMarketTypes.K_A:
    case AllMarketTypes.Numbers_2_to_9:
      return BetTypeCalculationTypes.MultiSelection;
    case AllMarketTypes.Hi_2:
    case AllMarketTypes.Hi_3:
    case AllMarketTypes.Hi_4:
    case AllMarketTypes.Hi_5:
    case AllMarketTypes.Hi_6:
    case AllMarketTypes.Hi_7:
    case AllMarketTypes.Hi_8:
    case AllMarketTypes.Hi_9:
    case AllMarketTypes.Hi_J:
    case AllMarketTypes.Hi_Q:
    case AllMarketTypes.Hi_K:
      return BetTypeCalculationTypes.Hi;
    case AllMarketTypes.Lo_3:
    case AllMarketTypes.Lo_4:
    case AllMarketTypes.Lo_5:
    case AllMarketTypes.Lo_6:
    case AllMarketTypes.Lo_7:
    case AllMarketTypes.Lo_8:
    case AllMarketTypes.Lo_9:
    case AllMarketTypes.Lo_A:
    case AllMarketTypes.Lo_J:
    case AllMarketTypes.Lo_K:
    case AllMarketTypes.Lo_Q:
      return BetTypeCalculationTypes.Lo;
    case AllMarketTypes.Number_2:
    case AllMarketTypes.Number_3:
    case AllMarketTypes.Number_4:
    case AllMarketTypes.Number_5:
    case AllMarketTypes.Number_6:
    case AllMarketTypes.Number_7:
    case AllMarketTypes.Number_8:
    case AllMarketTypes.Number_9:
    case AllMarketTypes.Q:
    case AllMarketTypes.J:
    case AllMarketTypes.K:
    case AllMarketTypes.A:
    case AllMarketTypes.Joker:
      return BetTypeCalculationTypes.ExactCard;
    default:
      return BetTypeCalculationTypes.ExactCardWithColor;
  }
};
